import { useSeo } from '../hooks/useSeo';

export default function Interpretation() {
  useSeo({ title: '문화 해석', description: '판소리와 국문학의 연계를 다루는 에세이와 작품 분석' });
  return (
    <div>
      <h2>문화적 해석</h2>
      <div className="section card">
        <h3>판소리와 국문학의 연계</h3>
        <p>해학성, 언어 미학, 서사 구조 등 국문학 이론을 판소리에 적용한 글과 강의 영상.</p>
      </div>
      <div className="section card">
        <h3>작품 분석</h3>
        <p>춘향가·수궁가·심청가 등 작품의 문화적·문학적 의미를 다각도로 해석합니다.</p>
      </div>
    </div>
  );
} 